import { Controller } from "@hotwired/stimulus"
import debounce from "lodash/debounce"

/**
 * Client-side filtering for privacy section tables (checks, web apps, device properties)
 * so filtering works in any locale without server round-trips.
 */
export default class extends Controller {
  static targets = ["searchInput", "searchForm", "row"]

  connect() {
    if (this.hasSearchInputTarget && this.searchInputTarget.value.trim() !== "") {
      this.searchInputTarget.value = ""
      this.searchList()
    }
  }

  searchList = debounce(() => {
    const term = this.searchInputTarget.value.trim().toLowerCase()
    this.rowTargets.forEach((row) => {
      const searchable = (row.dataset.searchable || "").toLowerCase()
      const show = term === "" || searchable.includes(term)
      row.style.display = show ? "" : "none"
    })
  }, 100)

  preventSubmit(event) {
    event.preventDefault()
  }
}
